// Fixed version of the PAR component - with getDefaultDates at component level
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Dropdown, Table, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import IconExcel from "../../../images/dashboard/icon-excel.png";
import IconPdf from "../../../images/dashboard/icon-pdf.png";
import { LuDownload } from "react-icons/lu";
import { useFormik } from "formik";
import * as Yup from "yup";
import { RxCalendar } from "react-icons/rx";
import IconInfo from "../../../images/dashboard/icon-info.png";
import ImageNoDataFound from '../../../images/nodata_found.gif';
import DatePicker from "react-multi-date-picker";
import DocumentUpload from "../../../components/DocumentUpload";
import axios from "axios";
import apiConfig from "../../credentials/apiConfig";
import Loader from "../../../components/Loader";
import './styles.scss';
import { toast } from "react-toastify";
import image from "../../../images/ai-robot.gif";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from 'react-markdown';
import html2pdf from 'html2pdf.js';
import PDFViewer from "./PdfViewer";
import DocumentExportTools from "./DocumentExportTool";
import ReactTextTransition from "react-text-transition";


const initialMessages = [
  "AI is analyzing your data. Please wait...",
  "Hang tight! Your analysis is in progress..."
];

const repeatMessages = [
  "Fetching your results. Almost there...",
  "Great things take time. Preparing your results now...",
  "Just a little longer. Thanks for your patience!"
];

const PAR = ({ onStepComplete, parData, handlePrevious, handleNext, engagementId, startDate, endDate, startDateModified, endDateModified, annualize}) => {
  // State for main component
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [financialData, setFinancialData] = useState([]);
  const [overallObservations, setOverallObservations] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedObservation, setSelectedObservation] = useState('');
  const [userModifiedDates, setUserModifiedDates] = useState({
    startDate: startDateModified || false,
    endDate: endDateModified || false
  });

  // State for modals
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [engagement, setEngagement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPolling, setIsPolling] = useState(false);
  const [status, setStatus] = useState("");
  const [parDataState, setParData] = useState(null);
  const [parsedStartDate, setParsedStartDate] = useState(null);
  const [parsedEndDate, setParsedEndDate] = useState(null);
  const [farStatus, setFarStatus] = useState("");
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    const [extraMessage, setExtraMessage] = useState("");

     useEffect(() => {
        let messageTimer, elapsedTimer;
      
        if (isPolling) {
          setCurrentMessageIndex(0);
          setElapsedSeconds(0);
          setExtraMessage("");
      
          messageTimer = setInterval(() => {
            setCurrentMessageIndex(prev => prev + 1);
          }, 5000);
      
          elapsedTimer = setInterval(() => {
            setElapsedSeconds(prev => prev + 1);
          }, 1000);
        }
      
        return () => {
          clearInterval(messageTimer);
          clearInterval(elapsedTimer);
        };
      }, [isPolling]);
      
        useEffect(() => {
          if (elapsedSeconds >= 300) {
            setExtraMessage("Thanks for your patience! Almost done.");
          } else if (elapsedSeconds >= 180) {
            setExtraMessage("Almost there. Please don’t close this tab.");
          } else if (elapsedSeconds >= 60) {
            setExtraMessage("Still working... Some files may take longer.");
          }
        }, [elapsedSeconds]);
        
        
      
      
      const getMessage = () => {
        if (currentMessageIndex < initialMessages.length) {
          return initialMessages[currentMessageIndex];
        } else {
          const loopIndex = (currentMessageIndex - initialMessages.length) % repeatMessages.length;
          return repeatMessages[loopIndex];
        }
      };

  
  // Define getDefaultDates function at the component level so it's accessible everywhere
  const getDefaultDates = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;
    
    const defaultStartDate = new Date(previousYear, 0, 1); // January 1st
    defaultStartDate.setHours(0, 0, 0, 0);
    
    const defaultEndDate = new Date(previousYear, 11, 31); // December 31st
    defaultEndDate.setHours(0, 0, 0, 0);
    
    return { defaultStartDate, defaultEndDate };
  };

useEffect(() => {
  if (!engagementId) return;

  let pollingInterval = null;

  const processPARData = (data) => {
    if (Array.isArray(data.PARClassifiedData) && data.PARClassifiedData.length > 0) {
      const processedData = data.PARClassifiedData.map((item, index) => ({
        id: index + 1,
        category: item.Category || "",
        group: item.Group || "",
        subGroup: item.Subgroup || "",
        account: item.AC || "",
        description: item.Description || "",
        currentYear: formatCurrency(item.Balance_CY),
        priorYear: formatCurrency(item.Balance_PY),
        change: formatCurrency(item.Change),
        percentChange: formatPercentage(item.PercentChange),
        significance: item.Significance || "Low",
        aiObservation: item.AIObservation || ""
      }));
      setFinancialData(processedData);
    }

    if (data.overallAIObservations?.length > 0) {
      setOverallObservations(data.overallAIObservations);
    }
  };

  const fetchPARStatus = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const res = await axios.post(
        `${apiConfig.apiBaseURL}/getEngagementStatus/${engagementId}`,
        { module: "par" },
        {
          headers: {
            "x-api-key": apiConfig["x-api-key"],
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { status, data, } = res.data;
      setStatus(status);
      setFarStatus(farStatus ||data?.farStatus || "");
      if (
        status === "completed" ||
        (data?.PARClassifiedData?.length > 0 || data?.overallAIObservations?.length > 0)
      ) {
        clearInterval(pollingInterval);
        setEngagement(res.data);
        setParData(res.data);
        processPARData(data);
        setLoading(false);
        setIsPolling(false);
        setStatus("");
      }else if (status === "failed") {
      clearInterval(pollingInterval);
      setLoading(false);
      setIsPolling(false);
      setStatus("");
      toast.error("PAR classification failed. Please try again.");
    } else if (status === "pending" && !pollingInterval) {
        setIsPolling(true);
        setLoading(true);
        setStatus("pending");
        // Set polling interval
        pollingInterval = setInterval(fetchPARStatus, 5000);
      }
    } catch (error) {
      console.error("Error fetching PAR status:", error);
      clearInterval(pollingInterval);
      setLoading(false);
      setIsPolling(false);
    }
  };

  const start = async () => {
    setIsLoading(true);
    await fetchPARStatus();
    setIsLoading(false);
  };

  start();

  return () => {
    clearInterval(pollingInterval);
    setIsPolling(false);
  };
}, [engagementId]);

  const handleShowModal = (text) => {
    setSelectedObservation(text);
    setShowModal(true);
  };

  // Process PAR data when it's available
  useEffect(() => {
    // console.log("Received PAR data:", parData);
    if (parData && parData.data && Array.isArray(parData.data)) {
      const processedData = parData.data.map((item, index) => ({
        id: index + 1,
        category: item.Category || "",
        group: item.Group || "",
        subGroup: item.Subgroup || "",
        account: item.AC || "",
        description: item.Description || "",
        currentYear: formatCurrency(item.Balance_CY),
        priorYear: formatCurrency(item.Balance_PY),
        change: formatCurrency(item.Change),
        percentChange: formatPercentage(item.PercentChange),
        significance: item.Significance || "Low",
        aiObservation: item.AIObservation || ""
      }));

      setFinancialData(processedData);
      setOverallObservations(parData.overallAIObservations || "");
    }
  }, [parData]);

  const parseUTCDate = (dateString) => {
    // console.log("PAR parseUTCDate input:", dateString);
    
    if (!dateString) {
      // console.log("parseUTCDate - null input, using default date");
      // Calculate default date based on current year (previous year Jan 1 - Dec 31)
      const currentYear = new Date().getFullYear();
      const defaultStartDate = new Date(currentYear - 1, 0, 1); // Jan 1 of previous year
      defaultStartDate.setHours(0, 0, 0, 0);
      return defaultStartDate;
    }
    
    try {
      let parsedDate;
      
      // Handle different possible date formats
      if (typeof dateString === 'string') {
        if (dateString.includes('T')) {
          // ISO format: 2022-01-01T00:00:00.000Z
          const dateParts = dateString.split('T')[0].split('-');
          const year = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1; // JS months are 0-indexed
          const day = parseInt(dateParts[2], 10);
          
          parsedDate = new Date(year, month, day);
        } else if (dateString.includes('-')) {
          // Simple date format: 2022-01-01
          const dateParts = dateString.split('-');
          const year = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1;
          const day = parseInt(dateParts[2], 10);
          
          parsedDate = new Date(year, month, day);
        } else {
          // Try direct parsing as a fallback
          parsedDate = new Date(dateString);
        }
      } else if (dateString instanceof Date) {
        // Already a Date object
        parsedDate = new Date(dateString);
      } else {
        // console.log("parseUTCDate - unsupported date format:", typeof dateString);
        // Return default date if format is unsupported
        const currentYear = new Date().getFullYear();
        const defaultStartDate = new Date(currentYear - 1, 0, 1);
        defaultStartDate.setHours(0, 0, 0, 0);
        return defaultStartDate;
      }
      
      // Verify the date is valid
      if (isNaN(parsedDate.getTime())) {
        // console.log("parseUTCDate - invalid date after parsing, using default");
        const currentYear = new Date().getFullYear();
        const defaultStartDate = new Date(currentYear - 1, 0, 1);
        defaultStartDate.setHours(0, 0, 0, 0);
        return defaultStartDate;
      }
      
      // console.log("parseUTCDate - result:", {
      //   parsedDate,
      //   parsedDateISO: parsedDate.toISOString(),
      //   parsedDateString: parsedDate.toString()
      // });
      
      return parsedDate;
    } catch (error) {
      console.error("parseUTCDate - error parsing date:", error);
      // Return default date on error
      const currentYear = new Date().getFullYear();
      const defaultStartDate = new Date(currentYear - 1, 0, 1);
      defaultStartDate.setHours(0, 0, 0, 0);
      return defaultStartDate;
    }
  };

  // console.log("Initializing uploadFormik with dates:", {
  //   parsedStartDate,
  //   parsedEndDate,
  //   annualize
  // });

  // console.log("PAR Component - Initial Props:", {
  //   startDate,
  //   endDate,
  //   annualize
  // });

  // Formik for file upload form with validation
  const uploadFormik = useFormik({
    initialValues: {
      file: "",
      startDate: parsedStartDate || "",
      endDate: parsedEndDate || "",
      annualize: annualize || false,
    },
    validationSchema: Yup.object({
      file: Yup.mixed().required("File is required"),
      startDate: Yup.date().required("Start date is required"),
      endDate: Yup.date().when('annualize', (annualize, schema) => {
        return annualize
          ? schema.nullable().notRequired()
          : schema
            .required("End date is required")
            .min(Yup.ref('startDate'), "End date must be after start date");
      }),
    }),
    onSubmit: (values) => handleGenerateFAR({ continueWithPreviousFile: false, values }),
  });

  useEffect(() => {
    const { defaultStartDate, defaultEndDate } = getDefaultDates();
    
    // Store info about user modifications
    setUserModifiedDates({
      startDate: startDateModified || false,
      endDate: endDateModified || false
    });
    
    // Parse startDate with proper priority logic
    if (startDate) {
      const parsed = parseUTCDate(startDate);
      // console.log("Parsed startDate:", {
      //   original: startDate,
      //   parsed: parsed,
      //   wasModifiedByUser: startDateModified
      // });
      setParsedStartDate(parsed);
    } else {
      console.log("No startDate provided from props, using default:", defaultStartDate);
      setParsedStartDate(defaultStartDate);
    }
    
    // Parse endDate with proper priority logic
    if (endDate) {
      const parsed = parseUTCDate(endDate);
      // console.log("Parsed endDate:", {
      //   original: endDate,
      //   parsed: parsed,
      //   wasModifiedByUser: endDateModified
      // });
      setParsedEndDate(parsed);
    } else {
      console.log("No endDate provided from props, using default:", defaultEndDate);
      setParsedEndDate(defaultEndDate);
    }
  }, [startDate, endDate, startDateModified, endDateModified]);
  
  // Update the uploadFormik useEffect to properly initialize form with the correct dates
  useEffect(() => {
    if (parsedStartDate && parsedEndDate) {
      // Reset form with the correct dates
      uploadFormik.resetForm({
        values: {
          ...uploadFormik.values,
          startDate: parsedStartDate,
          endDate: parsedEndDate,
          annualize: annualize || false
        }
      });
      
      // console.log("Updated uploadFormik values:", {
      //   startDate: parsedStartDate,
      //   endDate: parsedEndDate,
      //   annualize: annualize || false,
      //   userModifiedDates
      // });
    }
  }, [parsedStartDate, parsedEndDate, annualize, userModifiedDates]);

  useEffect(() => {
    
    // Get default dates from the component-level function
    const { defaultStartDate, defaultEndDate } = getDefaultDates();
    
    // Parse startDate with fallback to default
    if (startDate) {
      const parsed = parseUTCDate(startDate);
      // console.log("Parsed startDate:", {
      //   original: startDate,
      //   parsed: parsed
      // });
      setParsedStartDate(parsed);
    } else {
      console.log("No startDate provided from props, using default:", defaultStartDate);
      setParsedStartDate(defaultStartDate);
    }
    
    // Parse endDate with fallback to default
    if (endDate) {
      const parsed = parseUTCDate(endDate);
      // console.log("Parsed endDate:", {
      //   original: endDate,
      //   parsed: parsed
      // });
      setParsedEndDate(parsed);
    } else {
      console.log("No endDate provided from props, using default:", defaultEndDate);
      setParsedEndDate(defaultEndDate);
    }
  }, [startDate, endDate]);

  // Format currency value
  const formatCurrency = (value) => {
    if (value === undefined || value === null) return "$0.00";

    // Convert to number and check if it's a valid number
    const numValue = Number(value);
    if (isNaN(numValue)) return value;

    // Format as currency
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue);
  };

  // Format percentage value
  const formatPercentage = (value) => {
    if (value === undefined || value === null) return "0.0%";

    // Convert to number and check if it's a valid number
    const numValue = Number(value);
    if (isNaN(numValue)) return value;

    // Format as percentage with one decimal place
    return `${numValue.toFixed(1)}%`;
  };

  async function handleGenerateFAR({ continueWithPreviousFile, values = {} }) {
    setIsLoading(true);
    const authToken = localStorage.getItem("authToken");

    try {
      let dataToSend;


      if (continueWithPreviousFile) {
        dataToSend = {
          engagementId,
          continueWithPreviousFile: true,
        };
      } else {
        const formData = new FormData();
        formData.append("file", values.file);
        formData.append("engagementId", engagementId);
        formData.append("continueWithPreviousFile", false);
        formData.append("annualize", values.annualize);

        if (values.startDate) {
          formData.append("startDate", new Date(values.startDate).toISOString());
        }
        if (values.endDate) {
          formData.append("endDate", new Date(values.endDate).toISOString());
        }

        dataToSend = formData;
      }

      const response = await axios.post(
        `${apiConfig.apiBaseURL}/generateFAR`,
        dataToSend,
        {
          headers: {
            "x-api-key": apiConfig["x-api-key"],
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data && response.data.success) {
         handleNext();
      }

    } catch (err) {
      console.error("FAR API error:", err);
      toast.error(err.response?.data?.error || "An error occurred");
    } finally {
      setIsLoading(false);
      setShowConfirmationModal(false);
      setShowUploadModal(false);
    }
  }

  // Filter data based on search term and selected category
  const filteredData = financialData.filter(item => {
    const matchesSearch =
      (item.category && item.category.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.group && item.group.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.subGroup && item.subGroup.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.account && item.account.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.significance && item.significance.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesCategory = selectedCategory === "All Categories" ||
      item.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  // Get unique categories for the dropdown filter
  const categories = ["All Categories", ...new Set(financialData.map(item => item.category).filter(Boolean))];

  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const displayedData = filteredData.slice(offset, offset + itemsPerPage);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Event Handlers
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(0);
  };

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const handleContinueToFAR = () => {
    if (farStatus === 'completed') {
      handleNext();
      onStepComplete();
    } else {
      // Show the confirmation modal if data is not available
      setShowConfirmationModal(true);
    }
  };


  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
    uploadFormik.resetForm();
  };

  const handleSaveAndExit = () => {
    navigate('/engagements');
  };



if (status === "pending") {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1050,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "420px",
            backgroundColor: "#fff",
            borderRadius: "16px",
            padding: "40px 20px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
          }}
        >
          <img
            src={image}
            alt="Processing"
            style={{
              width: "120px",
              marginBottom: "20px",
            }}
          />
          <h5 style={{ fontWeight: 500, fontSize: "18px", color: "#333" }}>
            The AI is working on it.
          </h5>
              {/* <p style={{ fontSize: "14px", color: "#666" }}>
            This might take a little time, so please be patient.
          </p> */}

          <div className='d-flex justify-content-center'>
          <ReactTextTransition>
            {getMessage()}
          </ReactTextTransition>
          </div>
          {extraMessage && (
            <p style={{ fontSize: "14px", color: "#999", marginTop: "10px" }}>
              {extraMessage}
            </p>
          )}
          
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <Container fluid className="py-3 par-setup">
        <div className="bg-white p-3 rounded mb-4 border">
          <h5 className="mb-2 fw-bold">Overall Observations</h5>

          {overallObservations ? (
            <>
              <ReactMarkdown
                components={{
                  h1: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
                  h2: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
                  h3: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
                }}
              >
                {showMore ? overallObservations : overallObservations.slice(0, 300) + (overallObservations.length > 300 ? '...' : '')}
              </ReactMarkdown>

              {overallObservations.length > 300 && (
                <span
                  className="text-primary fw-bold cursor-pointer"
                  onClick={toggleShowMore}
                  style={{ cursor: 'pointer' }}
                >
                  {showMore ? 'Show less' : 'Show more'}
                </span>
              )}
            </>
          ) : (
            <p className="text-muted">No overall observations available.</p>
          )}
        </div>

        <div className="bg-white p-3 rounded mb-4">
          <Row className="mb-3 credential-page filter-block">
            <Col lg={6} md={12} className="mb-2 mb-md-0 d-flex search">
              <Form.Control
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="me-2"
                style={{ padding: '10px 30px' }}
              />

              <div className="d-flex ms-2 filter">
                <span className="me-2 fw-bold my-auto" style={{ fontSize: '14px' }}>Filters</span>
                <Dropdown>
                  <Dropdown.Toggle className="w-100 text-start border" style={{ padding: '10px 30px', backgroundColor: '#E7EFF8', color: '#677289' }}>
                    {selectedCategory}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {categories.map((category, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleCategoryChange(category)}
                      >
                        {category}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>

                <Col lg={6} md={12} className="d-flex justify-content-end mb-2 mb-md-0 actions">
  <DocumentExportTools
    engagementId={engagementId}
    documentType="par"
    documentData={parData?.data || financialData}
    observationsText={overallObservations}
    showViewOptions={true}
    showDownloadOptions={true}
  />
            </Col>
          </Row>

          {filteredData.length > 0 ? (
            <div className="table-responsive">
              <Table hover responsive style={{ border: "2px solid #E7ECF1" }}>
                <thead className="bg-light">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th className="text-light py-3">Category</th>
                    <th className="text-light py-3">Group</th>
                    <th className="text-light py-3">Sub Group</th>
                    <th className="text-light py-3">Account</th>
                    <th className="text-light py-3">Current Year</th>
                    <th className="text-light py-3">Prior Year</th>
                    <th className="text-light py-3">Change</th>
                    <th className="text-light py-3">% Change</th>
                    <th className="text-light py-3">Significance</th>
                    <th className="text-light py-3">AI Observation</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.map((item) => (
                    <tr key={item.id}>
                      <td className="text-light align-middle">{item.category}</td>
                      <td className="text-light align-middle">{item.group}</td>
                      <td className="text-light align-middle">{item.subGroup}</td>
                      <td className="text-light align-middle">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip className="custom-tooltip">
                              {item.description}
                            </Tooltip>
                          }
                        >
                          <span className="text-light ">{item.account}</span>
                        </OverlayTrigger>

                      </td>
                      <td className="text-light align-middle">{item.currentYear}</td>
                      <td className="text-light align-middle">{item.priorYear}</td>
                      <td className={item.change.includes('-') ? 'text-danger align-middle' : 'text-success align-middle'}>
                        {item.change}
                      </td>
                      <td className={item.percentChange.includes('-') ? 'text-danger align-middle' : 'text-success align-middle'}>
                        {item.percentChange}
                      </td>
                      <td className="align-middle">
                        <span className={`badge ${item.significance === 'High' ? 'bg-danger' :
                          item.significance === 'Medium' ? 'bg-warning text-dark' :
                            'bg-secondary'
                          }`}>
                          {item.significance}
                        </span>
                      </td>
                      {/* <td className="text-light">{item.aiObservation}</td> */}
                      <td className="text-light align-middle">
                        <>
                          {`${item.aiObservation.slice(0, 100)}${item.aiObservation.length > 100 ? '...' : ''}`}
                          {item.aiObservation.length > 100 && (
                            <span
                              className="text-primary fw-bold"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleShowModal(item.aiObservation)}
                            >
                              more
                            </span>
                          )}
                        </>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-4">
              <img src={ImageNoDataFound} alt="icon" />
              <p className="fw-bold text-dark mb-0">No matching records found</p>
            </div>
          )}

          {filteredData.length > 0 && (
            <Row className="d-flex justify-content-between align-items-center">
              <Col md={6}>
                <p className="mb-0">
                  Showing: {Math.min(offset + 1, filteredData.length)}-{Math.min(offset + itemsPerPage, filteredData.length)} of {filteredData.length}
                </p>
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel="..."
                  pageCount={totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination mb-0"}
                  activeClassName={"active"}
                  forcePage={currentPage}
                />
              </Col>
            </Row>
          )}
        </div>
      </Container>

      <Container fluid className="px-0 setup-footer">
        <Card className="h-100 py-4 px-3 mt-3" style={{ border: "2px solid #ECEEF5" }}>
          <div className="d-flex justify-content-between mt-3 all-buttons">
            <div className="left">
              <Button type='button' variant="outline-primary" className="px-5 py-3 me-3" onClick={handleSaveAndExit}>
                Save & Exit
              </Button>
              <Button type='button' variant="outline-primary" className="px-5 py-3" onClick={handlePrevious}>
                Back to Mapping
              </Button>
            </div>
            <div className="right">
              {/* <Button variant="outline-primary" className="px-5 py-3 me-3" onClick={goToDocumentSummary}>
                Skip to Document Summary
              </Button> */}
              <Button
                type='button'
                variant="primary"
                className="px-5 py-3"
                onClick={handleContinueToFAR}
              >
                Continue to FAR
              </Button>
            </div>
          </div>
        </Card>
      </Container>

      {/* FAR File Upload Confirmation Modal */}
      <Modal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        centered
        dialogClassName="upload-confirmation-modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">FAR File Upload Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want to continue with the previously uploaded file, or do you want to upload the final current-year trial balance file?</p>
          <div className="d-flex justify-content-between mt-4">
            <Button
              variant="outline-primary"
              className="px-4 py-2 fw-bold"
              onClick={() => handleGenerateFAR({ continueWithPreviousFile: true })}
              disabled={isLoading}
            >
              Continue with Previous File
            </Button>
            <Button
              variant="primary"
              className="px-4 py-2"
          onClick={() => {
  setShowConfirmationModal(false);
  
  // Reset form and parse dates before showing modal
  const parsedStart = parseUTCDate(startDate);
  const parsedEnd = parseUTCDate(endDate);
  
  // console.log("Opening upload modal with dates:", {
  //   startDate,
  //   endDate,
  //   parsedStart,
  //   parsedEnd,
  //   annualize
  // });
  
  // Use resetForm with values option to set initial values
  uploadFormik.resetForm({
    values: {
      file: "",
      startDate: parsedStart,
      endDate: parsedEnd,
      annualize: annualize || false
    }
  });
  
  setShowUploadModal(true);
}}
              disabled={isLoading}
            >
              Upload New File
            </Button>
          </div>
        </Modal.Body>
      </Modal>


      {/* Upload New File Modal */}
      <Modal
        show={showUploadModal}
        onHide={handleCloseUploadModal}
        centered
        dialogClassName="upload-new-file-modal credential-page"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Upload New File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={uploadFormik.handleSubmit}>
            {/* File Upload Component */}
            <DocumentUpload
              formik={uploadFormik}
              name="file"
              acceptedTypes={{
                "text/csv": [".csv"],
                "application/vnd.ms-excel": [".xls"],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              }}
              label=" "
            />

            <Form.Group className="mb-3 mt-4 position-relative">
              <Form.Label>Start Date</Form.Label>
            <DatePicker
  value={uploadFormik.values.startDate}
  onChange={(date) => {
    console.log("Start date changed:", date);
    uploadFormik.setFieldValue("startDate", date);
  }}
  inputClass="form-control"
  placeholder="MM/DD/YYYY"
  format="MM/DD/YYYY"
  disabled={uploadFormik.values.annualize}
/>
              <RxCalendar className="position-absolute end-0 translate-middle-y me-2 text-light" size="20px" style={{ top: "67%" }} />
              {uploadFormik.touched.startDate && uploadFormik.errors.startDate ? (
                <div className="text-danger mt-1">{uploadFormik.errors.startDate}</div>
              ) : null}
            </Form.Group>

            <Form.Group className="mb-3 position-relative">
              <Form.Label>End Date</Form.Label>
             <DatePicker
  value={uploadFormik.values.endDate}
  onChange={(date) => {
    uploadFormik.setFieldValue("endDate", date);
  }}
  inputClass="form-control"
  placeholder="MM/DD/YYYY"
  format="MM/DD/YYYY"
  disabled={uploadFormik.values.annualize}
/>
              <RxCalendar className="position-absolute end-0 translate-middle-y me-2 text-light" size="20px" style={{ top: "67%" }} />
              {uploadFormik.touched.endDate && uploadFormik.errors.endDate ? (
                <div className="text-danger mt-1">{uploadFormik.errors.endDate}</div>
              ) : null}
            </Form.Group>

            <Form.Group className="mb-3 d-flex">
              <Form.Check
                type="checkbox"
                id="annualize"
                label="Do you want to Annualize?"
                checked={uploadFormik.values.annualize}
                onChange={(e) => {
                  const checked = e.target.checked;
                  uploadFormik.setFieldValue("annualize", checked);
                }}
                name="annualize"
              />
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="button-tooltip-2">Annualizing allows you to project full-year
                  results from partial-year data.</Tooltip>}
              >
                <img className="my-auto mx-2" src={IconInfo} alt="info" style={{ cursor: "pointer", width: '18px', height: '18px' }} />
              </OverlayTrigger>
            </Form.Group>

            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-primary"
                className="me-2 px-3"
                onClick={handleCloseUploadModal}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="px-3"
                disabled={isLoading}
              >
                {isLoading ? "Uploading..." : "Upload"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="mb-0 fw-bold">AI Observation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-light">
          {selectedObservation}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toast container for notifications */}
      {/* <ToastContainer position="top-right" autoClose={3000} /> */}
    </>
  );
};

export default PAR;